import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { NaturalezaJuridica } from './naturalezas-juridica.model';

// LOAD
export const entityNaturalezaJuridicaLoadRequest = createAction(
  '[ENTITYNATURALEZAJURIDICA] Load Request'
);

export const entityNaturalezaJuridicaLoadFailure = createAction(
  '[ENTITYNATURALEZAJURIDICA] Load Failure',
  props<{ error: Error }>()
);

export const entityNaturalezaJuridicaLoadSuccess = createAction(
  '[ENTITYNATURALEZAJURIDICA] Load Success',
  props<{ items: NaturalezaJuridica[] }>()
);

// ADD
export const entityNaturalezaJuridicaAddRequest = createAction(
  '[ENTITYNATURALEZAJURIDICA] Add Request',
  props<{ item: NaturalezaJuridica }>()
);

export const entityNaturalezaJuridicaAddFailure = createAction(
  '[ENTITYNATURALEZAJURIDICA] Add Failure',
  props<{ error: Error }>()
);

export const entityNaturalezaJuridicaAddSuccess = createAction(
  '[ENTITYNATURALEZAJURIDICA] Add Success',
  props<{ item: NaturalezaJuridica }>()
);

// CHANGE
export const entityNaturalezaJuridicaChangeRequest = createAction(
  '[ENTITYNATURALEZAJURIDICA] Change Request',
  props<{ item: NaturalezaJuridica }>()
);

export const entityNaturalezaJuridicaChangeFailure = createAction(
  '[ENTITYNATURALEZAJURIDICA] Change Failure',
  props<{ error: Error }>()
);

export const entityNaturalezaJuridicaChangeSuccess = createAction(
  '[ENTITYNATURALEZAJURIDICA] Change Success',
  props<{ item: Update<NaturalezaJuridica> }>()
);

// DELETE
export const entityNaturalezaJuridicaDeleteRequest = createAction(
  '[ENTITYNATURALEZAJURIDICA] Delete Request',
  props<{ item: NaturalezaJuridica }>()
);

export const entityNaturalezaJuridicaDeleteFailure = createAction(
  '[ENTITYNATURALEZAJURIDICA] Delete Failure',
  props<{ error: Error }>()
);

export const entityNaturalezaJuridicaDeleteSuccess = createAction(
  '[ENTITYNATURALEZAJURIDICA] Delete Success',
  props<{ item: NaturalezaJuridica }>()
);
